// extracted by mini-css-extract-plugin
module.exports = {"root":"PatientQuestionnaire_root__6xnCD","header":"PatientQuestionnaire_header__2Kxvv","info":"PatientQuestionnaire_info__22iy8"};